// Nombre de un regalo leído del catálogo de la cadena por su SKU; mientras llega, o si falla, el de la línea.
import { useQuery } from '@tanstack/react-query';
import { getProduct } from '@/api/services/retail-catalog/retail-catalog.client';
import { itemDisplayName } from '@/shared/lib/format/itemDisplayName';

export function catalogProductKey(retailerId: string, sku: string) {
    return ['retail', 'product', retailerId, sku] as const;
}

export function CatalogGiftName({
    retailerId,
    sku,
    lineName,
}: {
    retailerId: string;
    sku: string;
    lineName: string;
}) {
    const { data } = useQuery({
        queryKey: catalogProductKey(retailerId, sku),
        queryFn: () => getProduct(retailerId, sku),
        staleTime: 5 * 60_000,
        retry: false,
    });
    if (!data) return <>{lineName}</>;
    return <>{itemDisplayName(data)}</>;
}
